import gql from "graphql-tag";

export default gql`

    mutation singleUploadMutation($file: Upload!){
        singleUpload(file: $file){
            url
        }
    }
`;
